import { z } from "zod";

// Le backend peut faire évoluer légèrement la forme des "sources" (nom des champs,
// présence du score...). On reste tolérant : tous les champs sont optionnels et un
// item qui ne correspond pas au schéma est simplement ignoré plutôt que de faire
// échouer l'affichage de la réponse.
export const ChatbotSourceSchema = z.object({
    theme: z.string().optional(),
    sectionTitle: z.string().optional(),
    score: z.number().optional(),
});

export type ChatbotSource = z.infer<typeof ChatbotSourceSchema>;

export const ChatbotAnswerSchema = z.object({
    conversationId: z.number(),
    messageId: z.number(),
    answer: z.string(),
    // Si le champ "sources" est absent ou mal formé, on retombe sur une liste vide
    // plutôt que de bloquer l'affichage de la réponse (cf. consigne produit).
    sources: z.array(ChatbotSourceSchema).catch([]),
});

export type ChatbotAnswer = z.infer<typeof ChatbotAnswerSchema>;

export type ChatbotQuestionRequest = {
    conversationId?: number;
    question: string;
};

export const CHATBOT_FEEDBACK_VALUES = ["THUMBS_UP", "THUMBS_DOWN"] as const;
export type ChatbotFeedback = (typeof CHATBOT_FEEDBACK_VALUES)[number];

export type ChatbotFeedbackRequest = {
    feedback: ChatbotFeedback;
};
